var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationMarker = function SvgLocationMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.179 14.143a3.964 3.964 0 1 0-3.965-3.964 3.964 3.964 0 0 0 3.965 3.964zm0-1.5a2.465 2.465 0 1 1 0-4.93 2.465 2.465 0 0 1 0 4.93z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.358 10.179a7.179 7.179 0 1 0-14.358 0c0 6.016 5.248 9.413 6.541 10.152.395.225.88.225 1.275 0 1.293-.738 6.542-4.134 6.542-10.152zm-7.179 8.787c1.29-.756 5.679-3.671 5.679-8.787a5.68 5.68 0 0 0-11.358 0c0 5.115 4.389 8.031 5.679 8.787z"
  })));
};
export default SvgLocationMarker;